var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 202,
    viewBox: "0 0 210 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.952 172.786H138.835C138.523 172.786 138.279 172.543 138.279 172.232C138.279 171.964 138.464 171.74 138.728 171.692C181.643 164.248 211.116 120.043 198.565 76.3099C187.77 32.6839 146.679 0.457048 101.139 0.846261C45.8727 0.768419 0.532877 45.708 0.606045 101.117C0.606045 154.274 42.0924 197.774 94.5197 201.165C96.7148 201.311 98.9147 201.389 101.144 201.389H209.462C196.516 183.947 175.375 172.815 151.957 172.786H151.952ZM92.5832 172.596C9.86912 160.944 7.60092 45.0366 89.6077 30.0519C132.909 22.7347 173.722 57.2287 173.307 101.117C173.746 144.203 134.328 178.045 92.5881 172.596H92.5832Z",
    fill: "#7033FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.199fd60a7901209e1a33d55f592ec8ec.svg";
export { ForwardRef as ReactComponent };